import axios from 'axios'
import {
    MessageBox,
    Message
} from 'element-ui'
// import store from '@/store'
// import {
//     getToken,
//     getUserid
// } from '@/utils/auth'

// import Alert from 'bootstrap-vue'

// create an axios instance   创建一个axios实例
const service = axios.create({
    baseURL: 'https://gys.yitipei.com/', // url = base url + request url  基础地址+清求地址
    // withCredentials: true, // send cookies when cross-domain requests  当跨域请求发送cookie
    timeout: 80000 // request timeout  请求超时
})

// request interceptor   请求拦截器
service.interceptors.request.use(
    config => {
        //     // do something before request is sent          发送请求之前做些什么

        //     if (store.getters.token) {
        //         // let each request carry token
        //         // ['X-Token'] is a custom headers key
        //         // please modify it according to the actual situation

        //         // config.headers['token'] = getToken()
        //         config.headers['Accept'] = process.env.NODE_ENV === 'development' ? '*/*' : 'application/json, text/plain, */*'
        //     // }
        //     // if (store.getters.userid) {
        //     //     config.headers['Admin-UserId'] = getUserid()
        //     // }
        return config
    },
    error => {
        // do something with request error  对错误做些什么
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor  响应拦截器
service.interceptors.response.use(
    /** 如果你想获得http标头或状态等信息
     * If you want to get http information such as headers or status
     * Please return  response => response
     */
    /**
     * Determine the request status by custom code  确定自定义代码的请求状态
     * Here is just an example
     * You can also judge the status by HTTP Status Code 你也可以判断状态通过HTTP状态代码
     */
    response => {
        const res = response.data

        // if the custom code is not 20000, it is judged as an error.
        if (res.code !== 200) {
            Message({
                message: res.msg || res.message || 'Error',
                type: 'error',
                duration: 5 * 1000
            })

            // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
            // if (res.code === 401 || res.code === 50008 || res.code === 50012 || res.code === 50014) {
            // to re-login
            // MessageBox.confirm('登录过期或失效', '请确认', {
            //     confirmButtonText: '重新登录',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            // }).then(() => {
            //     store.dispatch('user/resetToken').then(() => {
            //         location.reload()
            //     })
            // })
            // }
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            return res
        }
    },
    error => {
        console.log('err： ' + error) // for debug
            // 处理错误信息
        if (error.response) {
            const res = error.response.data
            if (res.code === 401) {
                MessageBox.confirm(res.message, '提示', {
                    confirmButtonText: '重新登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // store.dispatch('user/resetToken').then(() => {
                    //     location.reload()
                    // })
                }).catch(() => {})
            } else {
                Message({
                    showClose: true,
                    message: res.msg || error.message,
                    type: 'error',
                    duration: 5000
                })
            }
        } else {
            Message({
                message: '网络请求超时，请稍后再试', // error.message ||
                type: 'error',
                duration: 5 * 1000
            })
        }

        return Promise.reject(error)
    }
)

export default service